/** @format */

import React, { useEffect, useReducer, useState } from "react";
import Select from "react-select";
import BackgroundImg from "../../layout/BackgroundImg";
import Logo from "../../layout/Logo";
// import imgLogo from './assets/images/logo-light.png';
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { signUp } from "../../features/auth/authSlice";
import {
  fetchUserList,
  fetchUserTable,
  userRoleList,
} from "../../features/commonSlice/commonSlice";
import { addUser } from "../../features/userSlice/userSlice";
import useDecodedToken from "../../features/utils/hooks/useDecodedToken";
import { Button, Pagination, OverlayTrigger, Tooltip } from "react-bootstrap";

const ClientSignUp = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    mobile_no: "",
    role: null,
    manager: null,
    credit_in: "0",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const decodeToken = useDecodedToken();

  const {
    usersData,
    usersTableData,
    roleDataList,
    status: commonStatus,
  } = useSelector((state) => state.influencer);

  const [langList, setLangList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [usersTableList, setUsersTableList] = useState([]);
  const [usersList, setUsersList] = useState({ data: [] });
  const [errors, setErrors] = useState({});

  const [errorData, setErrorData] = useState([]);
  const [loginError, setLoginError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [roleList, setRoleList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    dispatch(fetchUserList());
    dispatch(fetchUserTable());
    dispatch(userRoleList());
  }, []);

  useEffect(() => {
    if (commonStatus === "succeeded") {
      setUsersList(usersData);
    }
  }, [commonStatus, usersData]);

  useEffect(() => {
    if (commonStatus === "succeeded") {
      setUsersTableList(usersTableData || []);
    }
  }, [commonStatus, usersTableData]);

  useEffect(() => {
    setRoleList(roleDataList?.data);
  }, [roleDataList]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error when the user starts typing or interacting
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear any existing error for this field
    }));

    // Handle phoneNo input to allow only numbers
    if (name === "mobile_no" || name === "credit_in") {
      if (value === "" || /^[0-9]{0,10}$/.test(value)) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }

    // Check if passwords match for both password and confirmPassword
    if (name === "password" || name === "confirmPassword") {
      if (formData.password !== value && name === "confirmPassword") {
        setPasswordError("Passwords do not match");
      } else if (formData.password === value || name === "password") {
        setPasswordError("");
      }
    }
  };

  useEffect(() => {
    const data = {
      name: "",
      email: "",
      password: "",
      mobile_no: "",
      role: null,
      manager: null,
      credit_in: "0", // ✅ default
    };

    setFormData(data);
    setInitialData(data);
  }, []);

  const handleSelectChange = (name, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear the error for the specific select field
    }));
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleReset = () => {
    if (initialData) {
      setFormData(initialData);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setIsLoading(true);
      const clientData = {
        name: formData.name,
        email: formData.email,
        password: formData.password,
        mobile_no: formData.mobile_no,
        role: formData.role?.value || "",
        manager: formData.manager?.value || "",
        credit_in: Number(formData.credit_in || 0),
      };

      await dispatch(addUser(clientData))
        .unwrap()
        .then((result) => {
          if (result.status) {
            toast.success(result.message);
            const newUser = {
              id: result?.data?.id || Math.random(),
              name: clientData.name || " ",
              email: clientData.email || " ",
              mobile_no: clientData.mobile_no || " ",
              role_name: formData.role?.label || "-",
              credit_in: formData.credit_in || " ",
              MgrName:
                usersList?.data?.find(
                  (user) => user.value === formData.manager?.value,
                )?.label || "-",
            };
            setUsersTableList((prevList) => [...prevList, newUser]);
            setFormData({
              name: "",
              email: "",
              password: "",
              mobile_no: "",
              role: null,
              manager: null,
              credit_in: "0",
            });
            navigate("/registered-user-list");
          } else {
            setLoginError(result.message);
            setErrorData(result.form_err);
          }
        })
        .catch((err) => {
          setLoginError(err.message);
          setErrorData(err.form_err || []);
          toast.error(err.message);
        });
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setIsLoading(false); // ✅ ALWAYS reset
    }
  };

  const mapErrors = (errorData) => {
    const errorMap = {};
    errorData.forEach((error) => {
      if (!errorMap[error.param]) {
        errorMap[error.param] = error.msg;
      }
    });
    return errorMap;
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };
  const handleToggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  useEffect(() => {
    const errorsValue = mapErrors(errorData);
    setErrors(errorsValue);
  }, [errorData]);

  const totalRecords = usersTableList?.length || 0;

  const totalPages =
    recordsPerPage === 2000 ? 1 : Math.ceil(totalRecords / recordsPerPage);

  const indexOfLast =
    recordsPerPage === 2000 ? totalRecords : currentPage * recordsPerPage;

  const indexOfFirst =
    recordsPerPage === 2000 ? 0 : indexOfLast - recordsPerPage;

  const currentData =
    recordsPerPage === 2000
      ? usersTableList
      : usersTableList.slice(indexOfFirst, indexOfLast);
  const getPaginationItems = (current, total) => {
    const pages = [];

    pages.push(1);

    if (current > 3) pages.push("...");

    for (
      let i = Math.max(2, current - 1);
      i <= Math.min(total - 1, current + 1);
      i++
    ) {
      pages.push(i);
    }

    if (current < total - 2) pages.push("...");

    if (total > 1) pages.push(total);

    return pages;
  };

  const handleBack = () => {
    navigate("/registered-user-list");
  };

  return (
    <>
    <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Register new user </h4>
          </div>
        </div>
      </div>
      <div className="rowr">
        

        <div className="row justify-content-center">
          <div className="card shadow-sm col-8">
            {/* ✅ HEADER */}
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Add New User</h5>

              <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleBack}
              >
                ← Back
              </Button>
            </div>

            {/* ✅ BODY */}
            <div className="card-body">
              <div className="row">
              <div class="col-lg-6 mb-3">
                <label htmlFor="name" className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Enter Name"
                  value={formData.name}
                  onChange={handleChange}
                />
                <div className="text-danger">
                  {errors.name && <>{errors.name}</>}
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <label htmlFor="email" className="form-label">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="Enter Email"
                  value={formData.email}
                  onChange={handleChange}
                />
                <div className="text-danger">
                  {errors.email && <>{errors.email}</>}
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <label htmlFor="password" className="form-label">
                  Password <span className="text-danger">*</span>
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  name="password"
                  placeholder="Enter Password"
                  value={formData.password}
                  onChange={handleChange}
                />
                <button
                  className="btn btn-link position-absolute end-0 text-decoration-none text-muted password-addon"
                  type="button"
                  style={{ marginTop: "-40px", marginRight: "10px" }}
                  onClick={handleTogglePassword}
                >
                  <i
                    className={`ri-${showPassword ? "eye-fill" : "eye-off-fill"} align-middle`}
                  ></i>
                </button>
                <div className="text-danger">
                  {errors.password && <>{errors.password}</>}
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <label htmlFor="mobile_no" className="form-label">
                  Mobile No <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="mobile_no"
                  placeholder="Enter Mobile No"
                  maxLength={10}
                  value={formData.mobile_no}
                  onChange={handleChange}
                />
                <div className="text-danger">
                  {errors.mobile_no && <>{errors.mobile_no}</>}
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <label htmlFor="role" className="form-label">
                  Select Role <span className="text-danger">*</span>
                </label>
                <Select
                  name="role"
                  options={roleList}
                  classNamePrefix="select"
                  value={formData.role}
                  onChange={(selected) => handleSelectChange("role", selected)}
                />
                <div className="text-danger">
                  {errors.role && <>{errors.role}</>}
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <label htmlFor="manager" className="form-label">
                  Select Manager{" "}
                </label>
                <Select
                  name="manager"
                  options={usersList?.data}
                  classNamePrefix="select"
                  value={formData.manager}
                  onChange={(selected) =>
                    handleSelectChange("manager", selected)
                  }
                />
                <div className="text-danger">
                  {errors.manager && <>{errors.manager}</>}
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <label htmlFor="manager" className="form-label">
                  Add Credits <span></span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="credit_in"
                  placeholder="Enter add credits value"
                  maxLength={10}
                  value={formData.credit_in}
                  onChange={handleChange}
                />
                <div className="text-danger">
                  {errors.credit_in && <>{errors.credit_in}</>}
                </div>
              </div>
              
              
              </div>
            </div>
            <div className="card-footer">
              <div className="row d-flex justify-content-end g-2">
                <p className="text-danger text-center">
                  {!errorData.length > 0 && loginError}
                </p>
                  <div className="col-lg-2">
                  <button
                  className="btn btn-danger w-100"
                  type="submit"
                  onClick={handleReset}
                >
                  Reset
                </button></div>
                <div className="col-lg-2">
                <button
                  className="btn btn-success w-100"
                  type="submit"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  ) : (
                    "Create User"
                  )}
                </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientSignUp;
